package empiresmp.feature.shop.backend.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PublicServerShop(
    @SerialName("title")
    val title: String,
    @SerialName("server_type")
    val serverType: ServerType,
    @SerialName("shop_items_data")
    val shopItemDatas: List<PublicShopItemData>
)
